import { createFileRoute } from '@tanstack/react-router';
import { importSearchSchema } from 'src/modules/communications/schemas/import-search.schema';
import ImportConversationsPage from 'src/modules/communications/components/pages/import-conversations.page';
import AuthenticateRoute from 'src/components/organisms/app-layouts/authenticate-route/authenticate-route';

export const Route = createFileRoute('/communications/import')({
  component: ImportLayoutComponent,
  validateSearch: (search) => importSearchSchema.parse(search),
});

function ImportLayoutComponent() {
  return (
    <AuthenticateRoute>
      <ImportConversationsPage />
    </AuthenticateRoute>
  );
}
